import { request } from '@/api/request'

// 获取授权配置
export const getAuthorizeConfig = () => request('/portal/v1/user/auth_config')

// 上传证书
export const uploadCertificate = data =>
  request('/portal/authorization/certificate', {
    method: 'post',
    timeout: 0,
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 更新授权
export const updateAuthorize = data =>
  request('/portal/v1/authorization/certificate', {
    method: 'put',
    data,
    timeout: 30 * 1000,
  })
